import { SVGProps } from "react"

const CloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 4L19.5 20"
        stroke={props.color || "#0E2846"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 20L20 4"
        stroke={props.color || "#0E2846"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
export default CloseIcon
